import { render } from "./403.vue?vue&type=template&id=dbafe944"
import script from "./403.vue?vue&type=script&lang=js"
export * from "./403.vue?vue&type=script&lang=js"
script.render = render

export default script